export default __webpack_public_path__ + "static/media/OpenSans-Regular.403af3bc.woff2";